<template>
  <main class="container my-5 px-3 px-lg-5">
    <h4>Categorias</h4>
    <ul class="list-inline">
      <li
        v-for="(listaCategoria, indexCategoria) in objCategoria"
        :key="indexCategoria"
      >
        <button
          class="align-items-center btn d-flex justify-content-between my-1 w-100"
          @click="itemClicked(listaCategoria.id)"
        >
          {{ listaCategoria.nome }}
          <span
            class="align-self-center h5 m-0"
            style="color: var(--cor-principal)"
            >&#10097;</span
          >
        </button>
        <ul class="list-inline ml-3">
          <li
            v-for="(listaSubCategoria,
            indexSubCategoria) in listaCategoria.subCategorias"
            :key="indexSubCategoria"
          >
            <button
              class="align-items-center btn d-flex justify-content-between my-1 w-100"
              @click="itemClicked(listaSubCategoria.id)"
            >
              {{ listaSubCategoria.nome }}
              <span
                class="align-self-center h5 m-0"
                style="color: var(--cor-principal)"
                >&#10097;</span
              >
            </button>
            <ul class="list-inline ml-3">
              <li
                v-for="(listaSubSubCategoria,
                indexSubSubCategoria) in listaSubCategoria.subCategorias"
                :key="indexSubSubCategoria"
              >
                <button
                  class="align-items-center btn d-flex justify-content-between my-1 w-100"
                  @click="itemClicked(listaSubSubCategoria.id)"
                >
                  {{ listaSubSubCategoria.nome }}
                  <span
                    class="align-self-center h5 m-0"
                    style="color: var(--cor-principal)"
                    >&#10097;</span
                  >
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </main>
</template>

<script>
import { APIService } from "../APIService";
const apiService = new APIService();

export default {
  name: "Categoria",
  components: {},
  data() {
    return {
      MODULOS: window.MODULOS,
      objCategoria: [],
    };
  },
  created() {
    window.scrollTo(0, 0);
    apiService.obterCategoria().then((res) => {
      const objTodas = { id: 0, nome: "Todas", posicaoOrdem: 1 };
      this.objCategoria = [objTodas, ...res];
    });
  },
  mounted() {
    document.getElementById("app").classList.add("bg");
  },
  destroyed() {
    document.getElementById("app").classList.remove("bg");
  },
  methods: {
    itemClicked(n) {
      const categoriaId = n > 0 ? n : null;
      this.$store.dispatch("selecionaCategoriaId", categoriaId);
      this.$router.push(`${this.MODULOS.LANDING ? "/loja" : "/"}`);
    },
  },
};
</script>

<style>
#app.bg {
  background: #ededed;
}
</style>
<style scoped lang="scss">
button {
  background-color: #fff;
  color: var(--cor-principal);
}
</style>
